// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/Dydu-Font-Icon.eot?46tx4h", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/Dydu-Font-Icon.ttf?46tx4h", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/Dydu-Font-Icon.woff?46tx4h", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/Dydu-Font-Icon.svg?46tx4h", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#Dydu-Font-Icon" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Dydu-Font-Icon';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('svg');
    font-weight: normal;
    font-style: normal;
    font-display: block;
}

.dydu-icons [class^='dydu-icon'],
.dydu-icons [class^='dydu-icon']:before,
.dydu-icons [class*=' dydu-icon'],
.dydu-icons [class*=' dydu-icon']:before {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: 'Dydu-Font-Icon' !important;
    speak: never;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;

    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.dydu-icons .icon-power:before {
    content: '\\e957' !important;
}

.dydu-icons .icon-time:before {
    content: '\\e958' !important;
}

.dydu-icons .icon-timer:before {
    content: '\\e959' !important;
}

.dydu-icons .icon-microphon:before {
    content: '\\e952' !important;
}

.dydu-icons .icon-pause:before {
    content: '\\e953' !important;
}

.dydu-icons .icon-play:before {
    content: '\\e954' !important;
}

.dydu-icons .icon-replay:before {
    content: '\\e955' !important;
}

.dydu-icons .icon-stop:before {
    content: '\\e956' !important;
}

.dydu-icons .icon-database:before {
    content: '\\e94a' !important;
}

.dydu-icons .icon-font-minus:before {
    content: '\\e94b' !important;
}

.dydu-icons .icon-printer:before {
    content: '\\e94c' !important;
}

.dydu-icons .icon-loading:before {
    content: '\\e94d' !important;
}

.dydu-icons .icon-font-plus:before {
    content: '\\e94e' !important;
}

.dydu-icons .icon-open-in-new:before {
    content: '\\e94f' !important;
}

.dydu-icons .icon-shield-lock:before {
    content: '\\e950' !important;
}

.dydu-icons .icon-email-send:before {
    content: '\\e951' !important;
}

.dydu-icons .icon-Visible:before {
    content: '\\e948' !important;
}

.dydu-icons .icon-Invisible:before {
    content: '\\e949' !important;
}

.dydu-icons .icon-chatbox_reduire:before {
    content: '\\e941' !important;
}

.dydu-icons .icon-chatbox_phone:before {
    content: '\\e942' !important;
}

.dydu-icons .icon-chatbox_mail:before {
    content: '\\e943' !important;
}

.dydu-icons .icon-chatbox_account:before {
    content: '\\e944' !important;
}

.dydu-icons .icon-chatbox_conversation:before {
    content: '\\e945' !important;
}

.dydu-icons .icon-chatbox_contact:before {
    content: '\\e946' !important;
}

.dydu-icons .icon-chatbox_option:before {
    content: '\\e947' !important;
}

.dydu-icons .icon-calendar:before {
    content: '\\e937' !important;
}

.dydu-icons .icon-dynamic:before {
    content: '\\e938' !important;
}

.dydu-icons .icon-equalizer:before {
    content: '\\e939' !important;
}

.dydu-icons .icon-feather:before {
    content: '\\e93a' !important;
}

.dydu-icons .icon-flag:before {
    content: '\\e93b' !important;
}

.dydu-icons .icon-handle:before {
    content: '\\e93c' !important;
}

.dydu-icons .icon-headphones:before {
    content: '\\e93d' !important;
}

.dydu-icons .icon-info-bulle:before {
    content: '\\e93e' !important;
}

.dydu-icons .icon-junction:before {
    content: '\\e93f' !important;
}

.dydu-icons .icon-whatsapp:before {
    content: '\\e940' !important;
}

.dydu-icons .icon-dots:before {
    content: '\\e936' !important;
}

.dydu-icons .icon-branche:before {
    content: '\\e935' !important;
}

.dydu-icons .icon-color-picker:before {
    content: '\\e934' !important;
}

.dydu-icons .icon-arrow-down:before {
    content: '\\e900' !important;
}

.dydu-icons .icon-arrow-left:before {
    content: '\\e901' !important;
}

.dydu-icons .icon-arrow-right:before {
    content: '\\e902' !important;
}

.dydu-icons .icon-arrow-up:before {
    content: '\\e903' !important;
}

.dydu-icons .icon-caret-down:before {
    content: '\\e904' !important;
}

.dydu-icons .icon-caret-left:before {
    content: '\\e905' !important;
}

.dydu-icons .icon-caret-right:before {
    content: '\\e906' !important;
}

.dydu-icons .icon-caret-up:before {
    content: '\\e907' !important;
}

.dydu-icons .icon-add:before {
    content: '\\e908' !important;
}

.dydu-icons .icon-check:before {
    content: '\\e909' !important;
}

.dydu-icons .icon-close:before {
    content: '\\e90a' !important;
}

.dydu-icons .icon-add-to-list:before {
    content: '\\e90b' !important;
}

.dydu-icons .icon-bell:before {
    content: '\\e90c' !important;
}

.dydu-icons .icon-bookmark:before {
    content: '\\e90d' !important;
}

.dydu-icons .icon-chart:before {
    content: '\\e90e' !important;
}

.dydu-icons .icon-chat-bubble:before {
    content: '\\e90f' !important;
}

.dydu-icons .icon-check-circle:before {
    content: '\\e910' !important;
}

.dydu-icons .icon-close-circle:before {
    content: '\\e911' !important;
}

.dydu-icons .icon-warning:before {
    content: '\\e912' !important;
}

.dydu-icons .icon-info:before {
    content: '\\e913' !important;
}

.dydu-icons .icon-code:before {
    content: '\\e914' !important;
}

.dydu-icons .icon-contact-book:before {
    content: '\\e915' !important;
}

.dydu-icons .icon-copy:before {
    content: '\\e916' !important;
}

.dydu-icons .icon-download:before {
    content: '\\e917' !important;
}

.dydu-icons .icon-eraser:before {
    content: '\\e918' !important;
}

.dydu-icons .icon-excel:before {
    content: '\\e919' !important;
}

.dydu-icons .icon-eye:before {
    content: '\\e91a' !important;
}

.dydu-icons .icon-hand:before {
    content: '\\e91b' !important;
}

.dydu-icons .icon-instagram:before {
    content: '\\e91c' !important;
}

.dydu-icons .icon-key:before {
    content: '\\e91d' !important;
}

.dydu-icons .icon-keyboard:before {
    content: '\\e91e' !important;
}

.dydu-icons .icon-link:before {
    content: '\\e91f' !important;
}

.dydu-icons .icon-magnifier:before {
    content: '\\e920' !important;
}

.dydu-icons .icon-mail:before {
    content: '\\e921' !important;
}

.dydu-icons .icon-masks:before {
    content: '\\e922' !important;
}

.dydu-icons .icon-maximize:before {
    content: '\\e923' !important;
}

.dydu-icons .icon-messenger:before {
    content: '\\e924' !important;
}

.dydu-icons .icon-minimize:before {
    content: '\\e925' !important;
}

.dydu-icons .icon-palette:before {
    content: '\\e926' !important;
}

.dydu-icons .icon-pencil:before {
    content: '\\e927' !important;
}

.dydu-icons .icon-profile:before {
    content: '\\e928' !important;
}

.dydu-icons .icon-puzzle:before {
    content: '\\e929' !important;
}

.dydu-icons .icon-send:before {
    content: '\\e92a' !important;
}

.dydu-icons .icon-signature:before {
    content: '\\e92b' !important;
}

.dydu-icons .icon-star:before {
    content: '\\e92c' !important;
}

.dydu-icons .icon-switch:before {
    content: '\\e92d' !important;
}

.dydu-icons .icon-target:before {
    content: '\\e92e' !important;
}

.dydu-icons .icon-thumb-down:before {
    content: '\\e92f' !important;
}

.dydu-icons .icon-thumb-up:before {
    content: '\\e930' !important;
}

.dydu-icons .icon-translate:before {
    content: '\\e931' !important;
}

.dydu-icons .icon-trash:before {
    content: '\\e932' !important;
}

.dydu-icons .icon-upload:before {
    content: '\\e933' !important;
}

.dydu-icons .icon-exit:before {
    content: "\\ea14" !important;
}
`, "",{"version":3,"sources":["webpack://./public/assets/Icomoon/style.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,4CAA2C;IAC3C;;yDAEmE;IACnE,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;;;IAII,+EAA+E;IAC/E,wCAAwC;IACxC,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;;IAEd,sCAAsC;IACtC,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":["@font-face {\n    font-family: 'Dydu-Font-Icon';\n    src: url('fonts/Dydu-Font-Icon.eot?46tx4h');\n    src: url('fonts/Dydu-Font-Icon.eot?46tx4h#iefix') format('embedded-opentype'),\n    url('fonts/Dydu-Font-Icon.ttf?46tx4h') format('truetype'), url('fonts/Dydu-Font-Icon.woff?46tx4h') format('woff'),\n    url('fonts/Dydu-Font-Icon.svg?46tx4h#Dydu-Font-Icon') format('svg');\n    font-weight: normal;\n    font-style: normal;\n    font-display: block;\n}\n\n.dydu-icons [class^='dydu-icon'],\n.dydu-icons [class^='dydu-icon']:before,\n.dydu-icons [class*=' dydu-icon'],\n.dydu-icons [class*=' dydu-icon']:before {\n    /* use !important to prevent issues with browser extensions that change fonts */\n    font-family: 'Dydu-Font-Icon' !important;\n    speak: never;\n    font-style: normal;\n    font-weight: normal;\n    font-variant: normal;\n    text-transform: none;\n    line-height: 1;\n\n    /* Better Font Rendering =========== */\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n.dydu-icons .icon-power:before {\n    content: '\\e957' !important;\n}\n\n.dydu-icons .icon-time:before {\n    content: '\\e958' !important;\n}\n\n.dydu-icons .icon-timer:before {\n    content: '\\e959' !important;\n}\n\n.dydu-icons .icon-microphon:before {\n    content: '\\e952' !important;\n}\n\n.dydu-icons .icon-pause:before {\n    content: '\\e953' !important;\n}\n\n.dydu-icons .icon-play:before {\n    content: '\\e954' !important;\n}\n\n.dydu-icons .icon-replay:before {\n    content: '\\e955' !important;\n}\n\n.dydu-icons .icon-stop:before {\n    content: '\\e956' !important;\n}\n\n.dydu-icons .icon-database:before {\n    content: '\\e94a' !important;\n}\n\n.dydu-icons .icon-font-minus:before {\n    content: '\\e94b' !important;\n}\n\n.dydu-icons .icon-printer:before {\n    content: '\\e94c' !important;\n}\n\n.dydu-icons .icon-loading:before {\n    content: '\\e94d' !important;\n}\n\n.dydu-icons .icon-font-plus:before {\n    content: '\\e94e' !important;\n}\n\n.dydu-icons .icon-open-in-new:before {\n    content: '\\e94f' !important;\n}\n\n.dydu-icons .icon-shield-lock:before {\n    content: '\\e950' !important;\n}\n\n.dydu-icons .icon-email-send:before {\n    content: '\\e951' !important;\n}\n\n.dydu-icons .icon-Visible:before {\n    content: '\\e948' !important;\n}\n\n.dydu-icons .icon-Invisible:before {\n    content: '\\e949' !important;\n}\n\n.dydu-icons .icon-chatbox_reduire:before {\n    content: '\\e941' !important;\n}\n\n.dydu-icons .icon-chatbox_phone:before {\n    content: '\\e942' !important;\n}\n\n.dydu-icons .icon-chatbox_mail:before {\n    content: '\\e943' !important;\n}\n\n.dydu-icons .icon-chatbox_account:before {\n    content: '\\e944' !important;\n}\n\n.dydu-icons .icon-chatbox_conversation:before {\n    content: '\\e945' !important;\n}\n\n.dydu-icons .icon-chatbox_contact:before {\n    content: '\\e946' !important;\n}\n\n.dydu-icons .icon-chatbox_option:before {\n    content: '\\e947' !important;\n}\n\n.dydu-icons .icon-calendar:before {\n    content: '\\e937' !important;\n}\n\n.dydu-icons .icon-dynamic:before {\n    content: '\\e938' !important;\n}\n\n.dydu-icons .icon-equalizer:before {\n    content: '\\e939' !important;\n}\n\n.dydu-icons .icon-feather:before {\n    content: '\\e93a' !important;\n}\n\n.dydu-icons .icon-flag:before {\n    content: '\\e93b' !important;\n}\n\n.dydu-icons .icon-handle:before {\n    content: '\\e93c' !important;\n}\n\n.dydu-icons .icon-headphones:before {\n    content: '\\e93d' !important;\n}\n\n.dydu-icons .icon-info-bulle:before {\n    content: '\\e93e' !important;\n}\n\n.dydu-icons .icon-junction:before {\n    content: '\\e93f' !important;\n}\n\n.dydu-icons .icon-whatsapp:before {\n    content: '\\e940' !important;\n}\n\n.dydu-icons .icon-dots:before {\n    content: '\\e936' !important;\n}\n\n.dydu-icons .icon-branche:before {\n    content: '\\e935' !important;\n}\n\n.dydu-icons .icon-color-picker:before {\n    content: '\\e934' !important;\n}\n\n.dydu-icons .icon-arrow-down:before {\n    content: '\\e900' !important;\n}\n\n.dydu-icons .icon-arrow-left:before {\n    content: '\\e901' !important;\n}\n\n.dydu-icons .icon-arrow-right:before {\n    content: '\\e902' !important;\n}\n\n.dydu-icons .icon-arrow-up:before {\n    content: '\\e903' !important;\n}\n\n.dydu-icons .icon-caret-down:before {\n    content: '\\e904' !important;\n}\n\n.dydu-icons .icon-caret-left:before {\n    content: '\\e905' !important;\n}\n\n.dydu-icons .icon-caret-right:before {\n    content: '\\e906' !important;\n}\n\n.dydu-icons .icon-caret-up:before {\n    content: '\\e907' !important;\n}\n\n.dydu-icons .icon-add:before {\n    content: '\\e908' !important;\n}\n\n.dydu-icons .icon-check:before {\n    content: '\\e909' !important;\n}\n\n.dydu-icons .icon-close:before {\n    content: '\\e90a' !important;\n}\n\n.dydu-icons .icon-add-to-list:before {\n    content: '\\e90b' !important;\n}\n\n.dydu-icons .icon-bell:before {\n    content: '\\e90c' !important;\n}\n\n.dydu-icons .icon-bookmark:before {\n    content: '\\e90d' !important;\n}\n\n.dydu-icons .icon-chart:before {\n    content: '\\e90e' !important;\n}\n\n.dydu-icons .icon-chat-bubble:before {\n    content: '\\e90f' !important;\n}\n\n.dydu-icons .icon-check-circle:before {\n    content: '\\e910' !important;\n}\n\n.dydu-icons .icon-close-circle:before {\n    content: '\\e911' !important;\n}\n\n.dydu-icons .icon-warning:before {\n    content: '\\e912' !important;\n}\n\n.dydu-icons .icon-info:before {\n    content: '\\e913' !important;\n}\n\n.dydu-icons .icon-code:before {\n    content: '\\e914' !important;\n}\n\n.dydu-icons .icon-contact-book:before {\n    content: '\\e915' !important;\n}\n\n.dydu-icons .icon-copy:before {\n    content: '\\e916' !important;\n}\n\n.dydu-icons .icon-download:before {\n    content: '\\e917' !important;\n}\n\n.dydu-icons .icon-eraser:before {\n    content: '\\e918' !important;\n}\n\n.dydu-icons .icon-excel:before {\n    content: '\\e919' !important;\n}\n\n.dydu-icons .icon-eye:before {\n    content: '\\e91a' !important;\n}\n\n.dydu-icons .icon-hand:before {\n    content: '\\e91b' !important;\n}\n\n.dydu-icons .icon-instagram:before {\n    content: '\\e91c' !important;\n}\n\n.dydu-icons .icon-key:before {\n    content: '\\e91d' !important;\n}\n\n.dydu-icons .icon-keyboard:before {\n    content: '\\e91e' !important;\n}\n\n.dydu-icons .icon-link:before {\n    content: '\\e91f' !important;\n}\n\n.dydu-icons .icon-magnifier:before {\n    content: '\\e920' !important;\n}\n\n.dydu-icons .icon-mail:before {\n    content: '\\e921' !important;\n}\n\n.dydu-icons .icon-masks:before {\n    content: '\\e922' !important;\n}\n\n.dydu-icons .icon-maximize:before {\n    content: '\\e923' !important;\n}\n\n.dydu-icons .icon-messenger:before {\n    content: '\\e924' !important;\n}\n\n.dydu-icons .icon-minimize:before {\n    content: '\\e925' !important;\n}\n\n.dydu-icons .icon-palette:before {\n    content: '\\e926' !important;\n}\n\n.dydu-icons .icon-pencil:before {\n    content: '\\e927' !important;\n}\n\n.dydu-icons .icon-profile:before {\n    content: '\\e928' !important;\n}\n\n.dydu-icons .icon-puzzle:before {\n    content: '\\e929' !important;\n}\n\n.dydu-icons .icon-send:before {\n    content: '\\e92a' !important;\n}\n\n.dydu-icons .icon-signature:before {\n    content: '\\e92b' !important;\n}\n\n.dydu-icons .icon-star:before {\n    content: '\\e92c' !important;\n}\n\n.dydu-icons .icon-switch:before {\n    content: '\\e92d' !important;\n}\n\n.dydu-icons .icon-target:before {\n    content: '\\e92e' !important;\n}\n\n.dydu-icons .icon-thumb-down:before {\n    content: '\\e92f' !important;\n}\n\n.dydu-icons .icon-thumb-up:before {\n    content: '\\e930' !important;\n}\n\n.dydu-icons .icon-translate:before {\n    content: '\\e931' !important;\n}\n\n.dydu-icons .icon-trash:before {\n    content: '\\e932' !important;\n}\n\n.dydu-icons .icon-upload:before {\n    content: '\\e933' !important;\n}\n\n.dydu-icons .icon-exit:before {\n    content: \"\\ea14\" !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
